exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){team-calendar-mobile .container.responsiveMobile{padding-bottom:30px}}team-calendar-mobile employee-search .employee-search-container.responsiveMobile{margin-top:10px;margin-bottom:20px}team-calendar-mobile .team-calendar-mobile{margin-right:-30px;margin-left:-30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarMobile.scss
// module id = 1304
// module chunks = 0